import { FC, PropsWithChildren, Suspense } from 'react'
import { values } from 'lodash-es'

import { TagsNoRef } from '@trustycars/genie-ui/types'
import { trueOrUndefined } from '@trustycars/genie-ui/functions'
import { useIsMounted } from '@trustycars/genie-ui/hooks'

import useSignal from '$actions/useSignal'

import queryParams from '$store/queryParams'
import { APP_LINKS } from '$constants'

import { lazyComponent as lazy } from '$app/utilities'

import Logo from '$icons/Logo'
import CopyrightText from '$elements/CopyrightText'

const Apk = lazy(() => import('$icons/DownloadBadge/Apk'))
const AppStore = lazy(() => import('$icons/DownloadBadge/AppStore'))
const PlayStore = lazy(() => import('$icons/DownloadBadge/PlayStore'))

import useLayoutClass from '$browser/useLayoutClass'

import {
  container,
  content,
  footer,
  main,
  logo,
  header,
  copyrightText,
  appLinks,
  appDownloads,
  appLinkBadges
} from './styles.css'

const hasAppLinks = values(APP_LINKS).some(Boolean)
const appLinkProps: TagsNoRef<'a'> = {
  title: 'Download Carro ID',
  className: appLinks
}

export const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
  useLayoutClass({ name: 'AuthLayout' })

  const {
    params: { device_id }
  } = useSignal(queryParams)

  const ready = useIsMounted()

  const cameFromDevice = !!device_id
  const showAppLinks = !cameFromDevice && hasAppLinks

  return (
    <section className={container} data-ready={trueOrUndefined(ready)}>
      <header className={header}>
        <Logo className={logo} />
      </header>

      <main className={main}>
        <article className={content}>{children}</article>

        <footer className={footer}>
          <CopyrightText className={copyrightText} />
          {showAppLinks && (
            <Suspense>
              <div className={appDownloads}>
                {APP_LINKS.playstore && (
                  <a href={APP_LINKS.playstore} {...appLinkProps}>
                    {/* @ts-expect-error props */}
                    <PlayStore className={appLinkBadges} />
                  </a>
                )}

                {APP_LINKS.apk && (
                  <a href={APP_LINKS.apk} download {...appLinkProps}>
                    {/* @ts-expect-error props */}
                    <Apk className={appLinkBadges} />
                  </a>
                )}

                {APP_LINKS.appstore && (
                  <a href={APP_LINKS.appstore} {...appLinkProps}>
                    {/* @ts-expect-error props */}
                    <AppStore className={appLinkBadges} />
                  </a>
                )}
              </div>
            </Suspense>
          )}
        </footer>
      </main>
    </section>
  )
}

export default AuthLayout
